//#region src/integrations/anthropic/anthropicTypes.ts
const ANTHROPIC_INTEGRATION_ID = "anthropic";

//#endregion
export { ANTHROPIC_INTEGRATION_ID };
//# sourceMappingURL=anthropicTypes.js.map